import { render, staticRenderFns } from "./OfficeMainButtons.vue?vue&type=template&id=13052356&scoped=true&"
import script from "./OfficeMainButtons.vue?vue&type=script&lang=js&"
export * from "./OfficeMainButtons.vue?vue&type=script&lang=js&"
import style0 from "./OfficeMainButtons.vue?vue&type=style&index=0&id=13052356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13052356",
  null
  
)

export default component.exports